import {
  ArrowRightIcon,
  BanIcon,
  Button,
  HospitalIcon,
  Paragraph,
} from '@quickmd-llc/design-system';
import { IN_PERSON_CLINIC_FULL_ADDRESS } from '@constants/InPersonClinicDetails';
import { useIsInPersonVisit } from '../hooks/useIsInPersonVisit';

type Props = { setInPersonVisitAcknowledgmentCompleted: StateSetter<boolean> };

const lineItems = (isInPersonVisitRequired: boolean) => [
  {
    icon: <BanIcon iconSize="l" />,
    title: 'Cannot be prescribed medications',
    description: isInPersonVisitRequired ? (
      <>
        Once you complete this required in-person visit and your account is no
        longer on hold, you will still need to schedule a virtual follow-up to
        receive your next Suboxone prescription, as the nurse <b>CANNOT</b>{' '}
        prescribe medication during the in-person visit.
      </>
    ) : (
      <>
        As a reminder, this visit will be with a nurse practitioner and while it
        will meet your state's requirement for an annual in-person visit,
        Suboxone <b>CANNOT</b> be prescribed. To receive your prescription,
        schedule a virtual follow-up with your provider.
      </>
    ),
  },
  {
    icon: <HospitalIcon iconSize="l" />,
    title: 'Clinic address',
    description: IN_PERSON_CLINIC_FULL_ADDRESS,
  },
];

export function InPersonVisitAcknowledgmentContent({
  setInPersonVisitAcknowledgmentCompleted,
}: Props) {
  const { isInPersonVisitRequired } = useIsInPersonVisit();

  return (
    <div className="items-between flex flex-1 flex-col items-stretch">
      <div className="flex-1">
        <Paragraph className="mb-4 font-semibold text-text-dark">
          What you need to know
        </Paragraph>

        <div className="flex flex-col gap-4">
          {lineItems(isInPersonVisitRequired).map((item) => (
            <div key={item.title} className="flex gap-sp-1">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-shade-10 p-2">
                {item.icon}
              </div>

              <div>
                <Paragraph className="font-semibold text-text-dark">
                  {item.title}
                </Paragraph>

                <Paragraph size="xs" className="text-text-light">
                  {item.description}
                </Paragraph>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Button onClick={() => setInPersonVisitAcknowledgmentCompleted(true)}>
        Book in-person visit <ArrowRightIcon />
      </Button>
    </div>
  );
}
